import React, { forwardRef } from 'react';

import SettingsIcon from '@atlaskit/icon/core/settings';

import { UserAction, type UserActionProps } from './user-action';

interface SettingsProps extends Omit<UserActionProps, 'icon'> {}

/**
 * __Settings__
 *
 * The Settings button for the top navigation.
 */
export const Settings = forwardRef<HTMLButtonElement, SettingsProps>((props, ref) => (
	<UserAction {...props} ref={ref} icon={SettingsIcon} />
));
